import { FieldValues, useController, UseControllerProps } from 'react-hook-form'

import SelectInput, { SelectInputProps } from './SelectInput'

type SelectInputControllerProps<T extends FieldValues> = UseControllerProps<T> & Omit<SelectInputProps, 'onBlur' | 'value'>

export default function SelectInputController<T extends FieldValues>(props: SelectInputControllerProps<T>) {
  const { control, name, InputProps, ...rest } = props
  const {
    field: { ref, ...otherFields },
    fieldState: { error },
  } = useController({ name, control })

  return <SelectInput {...rest} {...otherFields} InputProps={{ ...InputProps, ref }} error={!!error} helperText={error?.message} />
}
